export var PopupMenuDataTids = {
  root: 'PopupMenu__root',
  caption: 'PopupMenu__caption'
};